import { printLine, pause } from "../utilities.js";
import { state } from "../state.js";
import { screen } from "../screen.js";
import { Cell } from "../cell.js";

export const program = {
    name: "STPS",
    size: 78, // Number of lines of this 'program'
    list: async () => {
        await printLine("31 SYS 2735"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async () => {
        state.blockCursor = true;

        // Create a bitmap of the STPS logo
        const BITMAP = [
            "........................................",
            "........................................",
            "........................................",
            "........................OOO.............",
            "...........YYY.........OOO..............",
            ".............YY.YYYBBBOOOO..............",
            ".........YYYYYYYYBBBBBBOO...............",
            ".........Y...YYYBBBWO.BBO...............",
            "............YY.BBBBWOOBBB...............",
            "...........YY.BBBBBWWWBBB...............",
            "..........YY.BBBBBBBBBBBB...............",
            ".............BBBBBBBBBBBB...............",
            "..............BBBBBBBBBBB...............",
            "...............BBBBBBBBBB...............",
            "................BBBBBBWWBB..............",
            ".................BBBBBWWWB..............",
            ".................BBBBWWWWBB.............",
            ".................BBBBWWWWWB.............",
            ".................BBBBWWWWWB.............",
            "................BBBBBWWWWWWB............",
            "................BBBBBWWWWWWW............",
            "...............BBBBBWWWWWWWW............",
            "..............BBBBBBWWWWWWWWW...........",
            ".............BBBBBBBWWWWWWWWW...........",
            "............BBBBBBBWWWWWWWWWW..........."
        ];

        await screen.clearScreen();

        for (let i = 0; i < BITMAP.length; i++) {
            let line = [];
            for (let j = 0; j < BITMAP[i].length; j++) {
                switch (BITMAP[i][j]) {
                    case "O":
                        line.push(new Cell(" ", null, "orange"));
                        break;
                    case "Y":
                        line.push(new Cell(" ", null, "yellow"));
                        break;
                    case "B":
                        line.push(new Cell(" ", null, "black"));
                        break;
                    case "W":
                        line.push(new Cell(" ", null, "white"));
                        break;
                    default:
                        line.push(new Cell(" ", null, "blue"));
                }                
            }
            if (i === BITMAP.length - 1) {
                await printLine(line, { charDelay: 1, lineDelay: 1, endWithEnter: false, preventCursorShift: true });
            } else {
                await printLine(line, { charDelay: 1, lineDelay: 1, endWithEnter: false });
            }
        }
        
        setTimeout(() => {
          window.location.href = "https://www.shoot-the-penguin-studios.games"; // Redirect to the STPS page  
        }, 5000);
        await pause(10000);
    }
};